import { defineAction } from '~/prix'
import legalEntityImportAction from './legalEntityImport.action.json' with { type: 'json' }
import { z } from 'zod'

const legalEntityImportDefinition = defineAction({
  ...legalEntityImportAction,

  input: z.object({
    ignoreSpaceError: z.boolean().optional(),
    limit: z.number().min(1).optional(),
    forceFull: z.boolean().optional(),
    propagateOnly: z.boolean().optional(),
  }),
  output: z.object({}),
})

export default legalEntityImportDefinition
